import cz from './translations/lg-cz'
import en from './translations/lg-en'

export const  translations = {
  'cz': cz,
  'en': en,
};


